import React from "react";
import Rating from "@material-ui/lab/Rating";
import moment from "moment";
import ShowMoreText from "react-show-more-text";
import { useSelector } from "react-redux";

const FeedbackCard = ({ feedback, fromModal }) => {
  const language = useSelector((state) => state.store?.language);
  const themeColor = useSelector((state) => state.store.store.settings?.dark);

  const translateCreatedAt = (createdAtText) => {
    const createdAtTranslation = {
      Today: "اليوم",
      "This week": "هذا الاسبوع",
      "This month": "هذا الشهر",
      "This year": "هذه السنة",
      "More than a year ago": "منذ أكثر من عام",
    };
    return language === "arabic"
      ? createdAtTranslation[createdAtText]
      : createdAtText;
  };
  const { name, created, rating, comment } = feedback;
  const now = moment();
  const days = now.diff(created, "days");
  const weeks = now.diff(created, "weeks");
  const months = now.diff(created, "months");
  const years = now.diff(created, "years");
  const createdAt =
    days < 1
      ? translateCreatedAt("Today")
      : weeks < 1
      ? translateCreatedAt("This week")
      : months < 1
      ? translateCreatedAt("This month")
      : years < 1
      ? translateCreatedAt("This year")
      : translateCreatedAt("More than a year ago");

  return (
    <div
      className="card"
      style={{
        width: "100%",
        height: "100%",
        padding: fromModal ? 10 : "10px 45px",
        marginTop: fromModal ? 10 : 0,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingLeft: 10,
          paddingTop: 10,
          justifyContent: language === "arabic" ? "right" : "left",
        }}
      >
        <p style={{ fontWeight: "bold" }}>{name}</p>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingLeft: 10,
          justifyContent: language === "arabic" ? "right" : "left",
          flexDirection: language === "arabic" ? "row-reverse" : "row",
        }}
      >
        {rating ? (
          <Rating name="read-only" value={rating} readOnly size="small" />
        ) : (
          ""
        )}
        <span
          style={{
            marginLeft: rating === null || +rating === 0 ? 0 : 10,
            marginRight: rating === null || +rating === 0 || 0 ? 0 : 10,
          }}
        >
          {createdAt}
        </span>
      </div>

      <div
        style={{
          paddingLeft: 10,
          paddingTop: 10,
          paddingBottom: 10,
          textAlign: language === "arabic" ? "right" : "left",
        }}
      >
        <ShowMoreText
          more={
            <span
              style={{
                color: themeColor,
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              {language === "arabic" ? "أظهر المزيد" : "Read more"}
            </span>
          }
          less={
            <span
              style={{
                color: themeColor,
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              {language === "arabic" ? "عرض أقل" : "Show less"}
            </span>
          }
          expanded={false}
          truncatedEndingComponent={"..."}
        >
          {comment}
        </ShowMoreText>
      </div>
    </div>
  );
};

export default FeedbackCard;
